import { Link as RouterLink } from 'react-router-dom';

import ErrorOutline from '@mui/icons-material/ErrorOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const SystemError = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        maxWidth: '550px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <ErrorOutline sx={{ fontSize: 72 }} />
      </Box>
      <Typography variant="h3" component="h1" gutterBottom>
        Something Went Wrong
      </Typography>
      <Typography 
        variant="h5" 
        component="div" 
        align="center" 
        sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
      >
        It looks like something went wrong. Please return to the application and try your request
        again.
      </Typography>
      <Box sx={{ mt: 4 }}>
        <Button variant="contained" color="secondary" component={RouterLink} to="/">
          Back to Application
        </Button>
      </Box>
    </Box>
  );
};

export default SystemError;
